import { FC, ReactNode } from 'react';
import round from 'lodash/round';


type ScoreType = 'structural' | 'arc'

export type RenderProps = {
  score: number,
  progress: string
}

type Score = string | number

type Props = {
  type: ScoreType,
  score: Score
  render: (props: RenderProps) => ReactNode
}

export const Score: FC<Props> = ({ type, score, render }) => {
  const { progress, value } = getScoreData(type, score);

  return render({ score: value, progress });
};

export const MaxValueByType: Record<ScoreType, number> = {
  structural: 40,
  arc: 5,
};

export const getScoreData = (type: ScoreType, score: Score) => {
  const finalScore = typeof score === 'number' ? score : Number.parseFloat(score);
  const value = round(finalScore, 2);
  const maxValue = MaxValueByType[type];

  return {
    value,
    progress: `${value} / ${maxValue}`,
  };
};
